// import vet1 from "../images/vet2/오형석.png";
// import vet2 from "../images/vet2/송재용.png";
// import vet3 from "../images/vet2/조현기.png";
// import vet4 from "../images/vet/이창희.png";
// import vet5 from "../images/vet2/한창훈.png";
// import vet6 from "../images/vet2/박용관.png";
// import vet7 from "../images/vet2/김동우.png";
// import vet8 from "../images/vet2/강유리.png";
// import vet9 from "../images/vet2/이상빈.png";
// import vet10 from "../images/vet2/김창회.png";
// import vet11 from "../images/vet2/김민석.png";
// import vet12 from "../images/vet2/이태희.png";
// import vet13 from "../images/vet2/김민선.png";

// import tvet1 from "../images/vet/오형석.png";
// import tvet2 from "../images/vet/송재용.png";
// import tvet3 from "../images/vet/조현기.png";
// import tvet4 from "../images/vet/이창희.png";
// import tvet5 from "../images/vet/한창훈.png";
// import tvet6 from "../images/vet/박용관.png";
// import tvet7 from "../images/vet/김동우.png";
// import tvet8 from "../images/vet/강유리.png";
// import tvet9 from "../images/vet/이상빈.png";
// import tvet10 from "../images/vet/김창회.png";
// import tvet11 from "../images/vet/김민석.png";
// import tvet12 from "../images/vet/이태희.png";
// import tvet13 from "../images/vet/김민선.png";

let vet1,
  vet2,
  vet3,
  vet4,
  vet5,
  vet6,
  vet7,
  vet8,
  vet9,
  vet10,
  vet11,
  vet12,
  vet13,
  vet14,
  vet15,
  vet16,
  vet17,
  vet18,
  vet19,
  vet20,
  vet21,
  vet22,
  vet23,
  vet24,
  vet25;
let tvet1,
  tvet2,
  tvet3,
  tvet4,
  tvet5,
  tvet6,
  tvet7,
  tvet8,
  tvet9,
  tvet10,
  tvet11,
  tvet12,
  tvet13,
  tvet14,
  tvet15,
  tvet16,
  tvet17,
  tvet18,
  tvet19,
  tvet20,
  tvet21,
  tvet22,
  tvet23,
  tvet24,
  tvet25;

try {
  vet1 = require("../images/vet2/오형석.png");
} catch (e) {
  vet1 = require("../images/vet2/no-img.png");
}
try {
  vet2 = require("../images/vet2/송재용.png");
} catch (e) {
  vet2 = require("../images/vet2/no-img.png");
}
// try {
//   vet3 = require("../images/vet2/조현기.png");
// } catch (e) {
//   vet3 = require("../images/vet2/no-img.png");
// }
try {
  vet4 = require("../images/vet2/이창희.png");
} catch (e) {
  vet4 = require("../images/vet2/no-img.png");
}
try {
  vet5 = require("../images/vet2/한창훈.png");
} catch (e) {
  vet5 = require("../images/vet2/no-img.png");
}
try {
  vet6 = require("../images/vet2/박용관.png");
} catch (e) {
  vet6 = require("../images/vet2/no-img.png");
}
try {
  vet7 = require("../images/vet2/김동우.png");
} catch (e) {
  vet7 = require("../images/vet2/no-img.png");
}
try {
  vet8 = require("../images/vet2/강유리.png");
} catch (e) {
  vet8 = require("../images/vet2/no-img.png");
}
try {
  vet9 = require("../images/vet2/이상빈.png");
} catch (e) {
  vet9 = require("../images/vet2/no-img.png");
}
try {
  vet10 = require("../images/vet2/김창회.png");
} catch (e) {
  vet10 = require("../images/vet2/no-img.png");
}
try {
  vet11 = require("../images/vet2/김민석.png");
} catch (e) {
  vet11 = require("../images/vet2/no-img.png");
}
try {
  vet12 = require("../images/vet2/이태희.png");
} catch (e) {
  vet12 = require("../images/vet2/no-img.png");
}
try {
  vet13 = require("../images/vet2/김민선.png");
} catch (e) {
  vet13 = require("../images/vet2/no-img.png");
}
try {
  vet14 = require("../images/vet2/정연후.png");
} catch (e) {
  vet14 = require("../images/vet2/no-img.png");
}
try {
  vet15 = require("../images/vet2/유강연.png");
} catch (e) {
  vet15 = require("../images/vet2/no-img.png");
}
// try {
//   vet16 = require("../images/vet2/박길량.png");
// } catch (e) {
//   vet16 = require("../images/vet2/no-img.png");
// }
try {
  vet17 = require("../images/vet2/신승인.png");
} catch (e) {
  vet17 = require("../images/vet2/no-img.png");
}
try {
  vet18 = require("../images/vet2/허아영.png");
} catch (e) {
  vet18 = require("../images/vet2/no-img.png");
}
try {
  vet19 = require("../images/vet2/강채호.png");
} catch (e) {
  vet19 = require("../images/vet2/no-img.png");
}
try {
  vet20 = require("../images/vet2/김현우.png");
} catch (e) {
  vet20 = require("../images/vet2/no-img.png");
}
try {
  vet21 = require("../images/vet2/노유나.png");
} catch (e) {
  vet21 = require("../images/vet2/no-img.png");
}
try {
  vet22 = require("../images/vet2/이유진.png");
} catch (e) {
  vet22 = require("../images/vet2/no-img.png");
}
try {
  vet23 = require("../images/vet2/이종성.png");
} catch (e) {
  vet23 = require("../images/vet2/no-img.png");
}
try {
  vet24 = require("../images/vet2/양진호.png");
} catch (e) {
  vet24 = require("../images/vet2/no-img.png");
}
try {
  vet25 = require("../images/vet2/이재홍.png");
} catch (e) {
  vet25 = require("../images/vet2/no-img.png");
}

try {
  tvet1 = require("../images/vet/오형석.png");
} catch (e) {
  tvet1 = require("../images/vet/no-img.png");
}
try {
  tvet2 = require("../images/vet/송재용.png");
} catch (e) {
  tvet2 = require("../images/vet/no-img.png");
}
// try {
//   tvet3 = require("../images/vet/조현기.png");
// } catch (e) {
//   tvet3 = null;
// }
try {
  tvet4 = require("../images/vet/이창희.png");
} catch (e) {
  tvet4 = require("../images/vet/no-img.png");
}
try {
  tvet5 = require("../images/vet/한창훈.png");
} catch (e) {
  tvet5 = require("../images/vet/no-img.png");
}
try {
  tvet6 = require("../images/vet/박용관.png");
} catch (e) {
  tvet6 = require("../images/vet/no-img.png");
}
try {
  tvet7 = require("../images/vet/김동우.png");
} catch (e) {
  tvet7 = require("../images/vet/no-img.png");
}
try {
  tvet8 = require("../images/vet/강유리.png");
} catch (e) {
  tvet8 = require("../images/vet/no-img.png");
}
try {
  tvet9 = require("../images/vet/이상빈.png");
} catch (e) {
  tvet9 = require("../images/vet/no-img.png");
}
try {
  tvet10 = require("../images/vet/김창회.png");
} catch (e) {
  tvet10 = require("../images/vet/no-img.png");
}
try {
  tvet11 = require("../images/vet/김민석.png");
} catch (e) {
  tvet11 = require("../images/vet/no-img.png");
}
try {
  tvet12 = require("../images/vet/이태희.png");
} catch (e) {
  tvet12 = require("../images/vet/no-img.png");
}
try {
  tvet13 = require("../images/vet/김민선.png");
} catch (e) {
  tvet13 = require("../images/vet/no-img.png");
}
try {
  tvet14 = require("../images/vet/정연후.png");
} catch (e) {
  tvet14 = require("../images/vet/no-img.png");
}
try {
  tvet15 = require("../images/vet/유강연.png");
} catch (e) {
  tvet15 = require("../images/vet/no-img.png");
}
// try {
//   tvet16 = require("../images/vet/박길량.png");
// } catch (e) {
//   tvet16 = null;
// }
try {
  tvet17 = require("../images/vet/신승인.png");
} catch (e) {
  tvet17 = require("../images/vet/no-img.png");
}
try {
  tvet18 = require("../images/vet/허아영.png");
} catch (e) {
  tvet18 = require("../images/vet/no-img.png");
}
try {
  tvet19 = require("../images/vet/강채호.png");
} catch (e) {
  tvet19 = require("../images/vet/no-img.png");
}
try {
  tvet20 = require("../images/vet/김현우.png");
} catch (e) {
  tvet20 = require("../images/vet/no-img.png");
}
try {
  tvet21 = require("../images/vet/노유나.png");
} catch (e) {
  tvet21 = require("../images/vet/no-img.png");
}
try {
  tvet22 = require("../images/vet/이유진.png");
} catch (e) {
  tvet22 = require("../images/vet/no-img.png");
}
try {
  tvet23 = require("../images/vet/이종성.png");
} catch (e) {
  tvet23 = require("../images/vet/no-img.png");
}
try {
  tvet24 = require("../images/vet/양진호.png");
} catch (e) {
  tvet24 = require("../images/vet/no-img.png");
}
try {
  tvet25 = require("../images/vet/이재홍.png");
} catch (e) {
  tvet25 = require("../images/vet/no-img.png");
}

const vetInfo = [
  {
    id: 1,
    position: "영상진단센터장",
    sub: "원장수의사",
    name: "오형석",
    img: vet1,
    timg: tvet1,
    greetings:
      "치료는 아픈 아이들의 마음을 이해하는 것부터 시작입니다. 보호자님들과 아이들이 함께하는 시간의 시작과 끝을 책임지겠습니다.",
    history: [
      "전)강원대학교 수의과대학 부속동물병원 진료수의사",
      "전)원주스카이동물메디컬센터 영상의학과장",
      "현)원주스카이동물메디컬센터 원장",
    ],
    paper: [
      "Combination of dynamic and helical computed tomography for evaluation of patent ductus arteriosus in 10 dogs",
    ],
    education: [
      "강원대학교 수의학과 졸업",
      "강원대학교 수의과대학 대학원 석사 졸업(수의영상진단학 전공)",
    ],
    completion: [],
  },
  {
    id: 2,
    position: "정형신경센터장",
    sub: "원장수의사",
    name: "송재용",
    img: vet2,
    timg: tvet2,
    greetings: "모든 동물들이 건강하고 행복하도록 최선을 다하겠습니다.",
    history: [
      "전)강원대학교 수의과대학 부속동물병원 외과진료팀장",
      "전)인천스카이동물메디컬센터 외과과장",
      "전)인천스카이동물메디컬센터 외과원장",
      "현)원주스카이동물메디컬센터 원장",
    ],
    paper: [
      "Repair of Rabbit Radial Bone Defects Using Bone Morphogenetic Protein-2 Combined with 3D Porous Silk Fibroin/β-Tricalcium Phosphate Hybrid Scaffolds",
      "Sporothrix schenckii Infection in a Dog with Concurrent Hyperadrenocorticism and Diabetes Mellitus",
      "Successful Treatment of an Old Acquired Dysfunction of Tarsal Joint Using Pan Tarsal Arthrodesis in a Toy Poodle",
      "Use of Cell Sheets Expressing Bone Morphogenetic Protein-7 in the Management of a Nonunion Radial Fracture in a Toy Poodle",
    ],
    education: [
      "강원대학교 수의학과 졸업",
      "강원대학교 수의과대학 대학원 석사 졸업(수의외과학 전공)",
      "강원대학교 수의과대학 대학원 박사 과정(수의외과학 전공)",
    ],
    completion: [],
  },
  // {
  //   id: 3,
  //   position: "내과질환센터장",
  //   sub: "원장수의사",
  //   name: "조현기",
  //   img: vet3,
  //   timg: tvet3,
  //   greetings: "반려동물과 함께하는 가족의 행복을 위해 늘 함께 하겠습니다.",
  //   history: [
  //     "전)강원대학교 수의과대학 부속동물병원 내과진료팀장",
  //     "전)24시구리더케어동물의료센터 내과원장",
  //     "현)원주스카이동물메디컬센터 내과원장",
  //   ],
  //   paper: [
  //     "Nerve growth factore gene therapy increases the plasticity in the dorsal root ganglion in pyridoxien induced neuropathic dogs",
  //     "Beta-nerve growth factor gene therapy alleviates pyridoxine-induced neuropathic damage by increasing doublecortin and tyrosine kinase A in the dorsal root ganglion",
  //   ],
  //   education: [
  //     "서울대학교 산림과학부 졸업",
  //     "강원대학교 수의과대학 수의학과 졸업",
  //     "강원대학교 수의과대학 대학원 석사 졸업(수의내과학 전공)",
  //     "강원대학교 수의과대학 대학원 박사 수료",
  //   ],
  //   completion: [
  //     "2015 KSFM (Korea Society Of Feline Medicine) (광주) 컨퍼런스 참가",
  //     "2015 WVC(Western Veterinary Conference) (라스베가스) 참가",
  //     "2017 한국임상수의학회 제3회 소동물내시경 워크샵 (케네스 심슨 Kenneth Simpson 코넬대학교 교수 지도) 수료",
  //     "2018 ACVIM(American College Of Veterinary Interanl Medicine) Forum (시애틀) 및 포스터 발표",
  //     "2018 영남수의컨퍼런스 (대구) 참가",
  //     "2022 경기북부수의컨퍼런스 (고양시) 참가",
  //   ],
  // },
  {
    id: 4,
    position: "응급중환자센터장",
    sub: "원장수의사",
    name: "이창희",
    img: vet4,
    timg: tvet4,
    greetings:
      "근거 중심의 정확한 지식을 바탕으로 진정성 있는 수의사가 되도록 최선을 다하겠습니다.",
    history: [
      "전)원주스카이동물메디컬센터 진료수의사",
      "전)원주스카이동물메디컬센터 진료팀장",
      "전)원주스카이동물메디컬센터 응급진료과장",
      "현)원주스카이동물메디컬센터 원장",
      "강원대학교 수의예과 회장",
    ],
    paper: [],
    education: ["강원대학교 수의학과 졸업"],
    completion: [
      "강원대학교 부속 동물병원 임상 Rotation 과정 수료",
      "강원대학교 수의과대학 elective course : 임상병리실험실",
    ],
  },
  {
    id: 5,
    position: "정형신경과장",
    sub: "수의사",
    name: "한창훈",
    img: vet5,
    timg: tvet5,
    greetings:
      "아이들을 제 가족처럼 소중히 여기며 감동과 희망을 전하는 수의사가 되겠습니다.",
    history: [
      "현)원주스카이동물메디컬센터 외과과장",
      "한국고양이수의사회 정회원",
    ],
    paper: [
      "2018 한국임상수의학회 춘계 학술대회 구두발표 : Squamous cell carcinoma of nsal planum in a dog",
      "2018 한국임상수의학회 춘계 학술대회 포스터발표 : Amelanotic melanoma of laryngopharynx in a dog",
      "2019 한국임상수의학회 추계학술대회 구두 발표 : The Effect of Sustained Release of BMP-2 from Leaf-stacked structure Porous Beads on Allograft intergration in Radial Critical-sized Bone Defect Canine Model",
      "Effect of Screw insertion Torque on Mechanical Properties of a Hybrid Polyaxial Locking System",
    ],
    education: [
      "경상대학교 수의과대학 수의학과",
      "경상대학교 수의과대학 석사 졸업(수의외과학 전공)",
    ],
    completion: [
      "AOVET Course - Principles in small animal fracture management(Columbus, OH, USA)",
      "AoVET Course - Advanced Technique in small animal fracture management with 1-Day Wet Lab(Columbus, OH, USA)",
      "수의골관절학회 - 후지 관절의 수술적 질환 수료",
      "베터플릭스 - 골절 교정 수술 테크닉 실습 과정(Wet-lab) 수료",
      "제일메디칼 핸즈온 코스 - 3D 수술 가이드 활용 뼈 기형 교정법 핸즈온 코스 수료",
    ],
  },
  {
    id: 6,
    position: "정형신경과장",
    sub: "수의사",
    name: "박용관",
    img: vet6,
    timg: tvet6,
    greetings: "다정한 손길로, 숨은 질환도 꼼꼼하게 찾아내도록 하겠습니다.",
    history: [
      "건국대학교 수의외과학 실습 조교",
      "건국대학교 부속동물병원 외과진료 수의사",
      "현)원주스카이동물메디컬센터 외과과장",
    ],
    paper: [
      "Biomechanical comparison of bone staple fixation methods with suture material for median sternotomy closure using 3D-printed bone models",
    ],
    education: [
      "제주대학교 수의과대학 수의학과 졸업",
      "건국대학교 수의과대학 수의외과학 석사 졸업",
      "건국대학교 수의과대학 수의외과학 박사 과정",
    ],
    completion: [
      "한국수의외과학회 정회원",
      "AOVET Course - Principles in Small Animal Fracture Management, certificate",
      "AOVET Course - Advanced Techniques in Small Animal Fracture management certificate",
      "AOVET Master Course - Tibial Plateur Leveling Osteotomy (TPLO), certificate",
    ],
  },
  {
    id: 7,
    position: "정형신경과장",
    sub: "수의사",
    name: "김동우",
    img: vet7,
    timg: tvet7,
    greetings: "언제나 믿고 의지할 수 있는 평생 주치의가 되겠습니다.",
    history: [
      "전)강원대학교 수의과대학 부속동물병원 외과팀장",
      "전)공군수원비행장 군견진료담당 수의사",
      "현)원주스카이동물메디컬센터 외과과장",
    ],
    paper: [
      "description and biomechanical evaluation of modified laparoscopic assisted percutaneous gastropexy technique in dogs",
    ],
    education: [
      "강원대학교 수의학과 졸업",
      "강원대학교 수의과대학 대학원 석사 졸업(수의외과학 전공)",
    ],
    completion: [
      "한국임상수의학회 정회원",
      "2023 Small Animal Laparoscopy Masterclass Workshop(복강경) 이수",
      "2022 Small Animal Arthroscopy Workshop(관절경) 이수",
    ],
  },
  {
    id: 8,
    position: "내과질환과장/부원장",
    sub: "내과질환과장/부원장",
    name: "강유리",
    img: vet8,
    timg: tvet8,
    greetings:
      "모든 환자들은 특별하고 소중합니다. 아이들의 건강을 위해 헌신하겠습니다.",
    history: [
      "전)인천스카이동물메디컬센터 진료수의사",
      "전)원주스카이동물메디컬센터 진료수의사",
      "현)원주스카이동물메디컬센터 내과질환과장/부원장",
    ],
    paper: [],
    education: ["전남대학교 수의과대학 졸업"],
    completion: [
      "고양이수의사회 정회원",
      "21기 해마루 임상수의학 기본과정 수료",
    ],
  },
//   {
//     id: 9,
//     position: "영상진단과장",
//     sub: "수의사",
//     name: "이상빈",
//     img: vet9,
//     timg: tvet9,
//     greetings: "보호자님의 마음까지 공감할 수 있는 수의사가 되겠습니다.",
//     history: [
//       "강원대학교 수의과대학 수의영상의학 실습 조교",
//       "현)원주스카이동물메디컬센터 영상의학과 과장",
//       "한국수의영상의학 연구회 정회원",
//       "강원수의사회 정회원",
//       "대한수의사회 정회원",
//     ],
//     paper: [
//       "Optic nerve sheath diameter on MRI in small breed dogs with and without elevated intracranial pressure",
//     ],
//     education: [
//       "강원대학교 수의과대학 수의학과 졸업",
//       "강원대학교 수의과대학 수의영상의학 석사 졸업",
//     ],
//     completion: [
//       "2021 한국임상수의학회 춘계학술대회 참가",
//       "2021 한국임상수의학회 추계학술대회 참가",
//       "2022 한국임상수의학회 춘계학술대회 발표",
//     ],
//   },
  // {
  //   id: 16,
  //   position: "내과과장",
  //   sub: "수의사",
  //   name: "박길량",
  //   img: vet16,
  //   timg: tvet16,
  //   greetings:
  //     "반려동물의 작은 신호까지 놓치지 않는 섬세한 수의사가 되겠습니다.",
  //   history: ["현) 원주SKY동물메디컬센터 내과과장"],
  //   paper: [
  //     "Thromboelastography parameters between single and multiple disease groups and clopidogrel effectiveness in dogs with multiple disease",
  //   ],
  //   education: [
  //     "강원대학교 생명과학과 졸업",
  //     "강원대학교 수의과대학 수의학과 졸업",
  //     "강원대학교 수의과대학 대학원 석사 졸업 (수의내과학 전공)",
  //   ],
  //   completion: [],
  // },
//   {
//     id: 11,
//     position: "임상병리과장",
//     sub: "수의사",
//     name: "김민석",
//     img: vet11,
//     timg: tvet11,
//     greetings:
//       "환자와 보호자님의 입장에서 생각하고 최선을 다해 진료하겠습니다.",
//     history: [
//       "강원대학교 수의과대학 대동물내과학 실험실 학부생 연구원",
//       "강원대학교 수의과대학 수의임상병리학 실습 조교",
//       "전)농림축산검역본부 공중방역수의사 복무",
//       "한국수의종양의학연구회(KVOS) 정회원",
//     ],
//     paper: [],
//     education: [
//       "강원대학교 수의과대학 졸업",
//       "강원대학교 수의과대학 수의임상병리학 석사수료",
//     ],
//     completion: [],
//   },
//   {
//     id: 10,
//     position: "진료/치과과장",
//     sub: "진료/치과과장",
//     name: "김창회",
//     img: vet10,
//     timg: tvet10,
//     greetings: "아이들을 사랑하는 수의사, 따뜻한 손길로 치료하겠습니다.",
//     history: [
//       "충청북도 동물위생시험소 공중방역 수의사",
//       "현)원주스카이동물메디컬센터 진료수의사",
//     ],
//     paper: [],
//     education: ["강원대학교 수의과대학 수의학과 졸업"],
//     completion: [],
//   },
//   {
//     id: 15,
//     position: "진료수의사",
//     sub: "수의사",
//     name: "유강연",
//     img: vet15,
//     timg: tvet15,
//     greetings:
//       "보호자님과 반려동물의 행복한 추억을 함께 만들어가는 수의사가 되겠습니다.",
//     history: [
//       "대한민국 해군 1함대 수의장교 대위 전역",
//       "현) 원주SKY동물메디컬센터 진료 수의사",
//     ],
//     paper: [],
//     education: [
//       "강원대학교 수의과대학 수의학과 졸업",
//       "강원대학교 야생동물질병학 실험실",
//     ],
//     completion: [],
//   },
  {
    id: 12,
    position: "진료과장",
    sub: "수의사",
    name: "이태희",
    img: vet12,
    timg: tvet12,
    greetings:
      "저와 만난 모든 아이들과 보호자님이 언제나 건강하고 행복하길 바라겠습니다.",
    history: ["현)원주스카이동물메디컬센터 진료과장"],
    paper: [],
    education: ["강원대학교 수의과대학 수의학과 졸업"],
    completion: [],
  },
  {
    id: 20,
    position: "진료과장",
    sub: "수의사",
    name: "김현우",
    img: vet20,
    timg: tvet20,
    greetings: "반려동물과 함께하는 가족의 행복을 위해 늘 함께 하겠습니다.",
    history: [
        "전)경기 광주 그렌드동물병원 진료수의사",
        "현) 원주스카이동물메디컬센터 진료수의사",
    ],
    paper: [
    ],
    education: [
        "강원대학교 수의학과 졸업",
    ],
    completion: [],
  },
  {
    id: 25,
    position: "진료과장",
    sub: "수의사",
    name: "이재홍",
    img: vet25,
    timg: tvet25,
    greetings: "반려동물과 함께하는 가족의 행복을 위해 늘 함께 하겠습니다.",
    history: [
        "전) 천안나우동물메디털센터 진료 수의사",
    ],
    paper: [
    ],
    education: [
        "전) 충남대학교 졸업",
    ],
    completion: [],
  },
  {
    id: 22,
    position: "정형신경과장",
    sub: "수의사",
    name: "이유진",
    img: vet22,
    timg: tvet22,
    greetings: "환자와 보호자님의 마음까지 치료하는 수의사가 되겠습니다.",
    history: [
        "전) 충북대학교 부속동물병원 외과 진료수의사",
        "전) 천안나우동물의료센터 외과 진료수의사",
        "현) 원주스카이동물메디컬센터 외과과장",
    ],
    paper: [
        "Americn college of veterinary sports medicine and rehabilitation symposium 참석"
    ],
    education: [
        "충북대학교 수의과대학 졸업",
        "충북대학교 수의외과학 석사과정",
    ],
    completion: [],
  },
//   {
//     id: 13,
//     position: "진료수의사",
//     sub: "수의사",
//     name: "김민선",
//     img: vet13,
//     timg: tvet13,
//     greetings: "환자와 보호자님의 마음까지 치료하는 수의사가 되겠습니다.",
//     history: [
//       "전)하비동물병원 진료수의사",
//       "현)원주스카이동물메디컬센터 진료수의사",
//     ],
//     paper: [],
//     education: ["건국대학교 수의학과 졸업"],
//     completion: [],
//   },
//   {
//     id: 14,
//     position: "응급과장",
//     sub: "수의사",
//     name: "정연후",
//     img: vet14,
//     timg: tvet14,
//     greetings: "반려동물의 마음까지 이해하는 따뜻한 수의사가 되겠습니다.",
//     history: [
//       "충남대학교 동물병원 피부과 진료수의사",
//       "대전야생동물구조관리센터 수의사",
//       "현) 원주SKY동물메디컬센터 응급과장",
//     ],
//     paper: [
//       "2022.10.16 한국임상수의학회 추계학술대회 구두 발표 Topical application of pimecrolimus in the treatment of discoid lupus erythematosus in a dog",
//       "한국임상수의학회 추계학술대회 구두 발표 Cutaneous xanthoma in a dog",
//       "한국임상수의학회지 10월호 case report 게재 Cutaneous xanthoma in a dog",
//       "한국임상수의학회지 2월호 case report 게재 Adjunctive therapy of pimecrolimus for treatment of facial discoid lupus erythematosus in a dog",
//     ],
//     education: [
//       "충남대학교 수의학과 졸업",
//       "충남대학교 수의과대학 대학원 임상수의학 석사 졸업",
//     ],
//     completion: [],
//   },
  {
    id: 19,
    position: "응급과장",
    sub: "수의사",
    name: "강채호",
    img: vet19,
    timg: tvet19,
    greetings: "언제나 믿고 의지할 수 있는 평생의 동반자가 되겠습니다.",
    history: [
        "대전 숲동물의료센터 임상로테이션",
        "전)대구광역시 북구 공중방역수의사",
        "전)바른동물병원 진료과장",
        "현)원주스카이동물메디컬센터 응급과장",
    ],
    paper: [
    ],
    education: [
        "충남대학교 수의과대학 졸업",
    ],
    completion: [],
  },
  {
    id: 17,
    position: "진료수의사",
    sub: "수의사",
    name: "신승인",
    img: vet17,
    timg: tvet17,
    greetings: "보호자님의 마음까지 공감할 수 있는 수의사가 되겠습니다.",
    history: [
    //   "전남대학교 수의과대학 졸업",
      "현)원주스카이동물메디컬센터 진료수의사",
    ],
    paper: [
    ],
    education: [
      "전남대학교 수의과대학 졸업",
    //   "현)원주스카이동물메디컬센터 진료수의사",
    ],
    completion: [],
  },
  {
    id: 18,
    position: "진료수의사",
    sub: "수의사",
    name: "허아영",
    img: vet18,
    timg: tvet18,
    greetings: "아이들을 사랑하는 수의사, 따뜻한 손길로 치료하겠습니다.",
    history: [
        "강원대학교 동물병원 수의임상로테이션 수료",
        "강원대학교 동물병원 응급중환자의학과 학부연구생",
        "한국고양이수의사회 정회원",
        "현) 원주SKY동물메디컬센터 내과질환센터 진료수의사",
    ],
    paper: [
    ],
    education: [
        "강원대학교 수의과대학 수의학사 졸업",
    ],
    completion: [],
  },
  {
    id: 24,
    position: "진료수의사",
    sub: "수의사",
    name: "양진호",
    img: vet24,
    timg: tvet24,
    greetings: "저와 만난 모든 아이들과 보호자님이 언제나 건강하고 행복하길 바라겠습니다.",
    history: [
        "강원대학교 동물병원 수의임상로테이션 수료",
        "강원특별자치도 춘천시 공중방역수의사 근무",
    ],
    paper: [
    ],
    education: [
        "강원대학교 수의과대학 수의학과 졸업",
    ],
    completion: [],
  },
//   {
//     id: 21,
//     position: "진료수의사",
//     sub: "수의사",
//     name: "노유나",
//     img: vet21,
//     timg: tvet21,
//     greetings: "저와 만난 모든 아이들과 보호자님이 언제나 건강하고 행복하길 바라겠습니다.",
//     history: [
//         "현) 원주스카이동물병원메디컬센터 진료수의사",
//         "일본북해도 오비히로대학 수의학 내과교실 연구생",
//         "일본나가노현 키타야마라베스회사 검사개발센터역임",
//         "일본동북대학 의과대학 연구실에서 실험동물담당역임",
//     ],
//     paper: [
//     ],
//     education: [
//         "충남대학교 수의과대학 수의학과 졸업",
//     ],
//     completion: [],
//   },
  {
    id: 23,
    position: "진료수의사",
    sub: "수의사",
    name: "이종성",
    img: vet23,
    timg: tvet23,
    greetings: "아이들을 사랑하는 수의사, 따뜻한 손길로 치료하겠습니다.",
    history: [
        "충청북도 동물위생시험소 북부지소 공중방역수의사 검사관",
        "현) 원주스카이동물메디컬센터 진료수의사",
    ],
    paper: [
    ],
    education: [
        "충남대학교 수의과대학 수의학과 졸업",
    ],
    completion: [],
  },
];

export default vetInfo;
